import TemplateFlex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled from '../../../../theme'

const Flex:any = styled(TemplateFlex as any)<any>`
  font-size: ${({ size }) => (size ? 0.8 * size : 0.8)}em;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    position: relative; 
    width: ${({ size }) => (size ? 200 * size : 200)}px;
    font-size: ${({ size }) => (size ? 16 * size : 16)}px;
    white-space: nowrap;
  }

  ${is('print')`
  	font-size: 16px;
  `}
`

export default Flex as any
